import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

export interface AssetWithDocument {
  clientDocument: string;
  [key: string]: any;
}

export interface AssetItemProps<T extends AssetWithDocument> {
  item: T;
  label: string;
  value?: string;
  rows?: number;
  columns?: number;
  onSelectClient?: (clientDocument: string) => void;
}

export const AssetItem = <T extends AssetWithDocument>({
  label,
  value = '',
  rows = 1,
  columns = 3,
  item,
  onSelectClient,
}: AssetItemProps<T>) => {
  return (
    <VStack
      justifyContent="space-between"
      alignContent="center"
      space={Spacing['inline.quarck']}
      minW={110}
      w={rows !== 1 ? `${100 / columns}%` : undefined}>
      <Text fontSize={Typography['fontsize.xs']} variant="semibold" color="neutral.black">
        {label}
      </Text>
      {label === 'Cliente' ? (
        <Pressable onPress={() => onSelectClient?.(item.clientDocument)}>
          <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
            {value}
          </Text>
        </Pressable>
      ) : (
        <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
          {value}
        </Text>
      )}
    </VStack>
  );
};
